import { render, staticRenderFns } from "./InterRateManagement.vue?vue&type=template&id=2c1dce89&"
import script from "./InterRateManagement.vue?vue&type=script&lang=js&"
export * from "./InterRateManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports